import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { UPLOAD_SOURCES } from '@cld/upload-widget';
import { selectPalette } from 'root/selectors';
import t from 'common/i18n';
import TabPanel from 'tabs/hocs/TabPanel';
import TabFooter from 'root/components/TabFooter';
import Button from 'root/components/Button';
import SVG_ICONS from '~/assets/icons/icons';

import './UrlTab.scss';

const GTitle = styled.div.attrs({ className: cx('mb5 f2 bg-source-bg-c w-100') })({
  marginBottom: '22px',
  maxWidth: '628px',
});

const GSearchWrap = styled.div.attrs({ className: cx('flex items-center relative overflow-hidden w-100') })({
  maxWidth: '628px',
  flexShrink: '0',
});

const GInput = styled.input.attrs({ className: cx('bc-link', 'w-100 ba br1 f-5 pt4 pb4 pl5 pr8 outline-0 bg-window') })({
  // TODO: Remove weight overright after scss removal
  '&&': {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 12,
    paddingRight: 44,
    height: 'inherit',
  },
});

const GButton = styled.div.attrs({ className: cx('absolute') })({
  right: '1px',
  top: '0',
  bottom: '0',
});

export class UrlTab extends React.Component {
  componentDidMount() {
    if (this.inputRef) {
      this.inputRef.focus();
    }
  }

  onInputKeyDown = (e) => {
    if (e.which === 13) {
      this.sendUrlToUpload();
    }
  };

  onUploadClick = () => {
    this.sendUrlToUpload();
  };

  inputRef = null;

  sendUrlToUpload() {
    if (this.inputRef) {
      this.props.addToUploadQueue({
        files: [this.inputRef.value],
      });
    }
  }

  render() {
    return (
      <>
        <div className="holder large-thin-menu-holder flex flex-column justify-content-center items-center pl7 pr7 w-100">
          <GTitle>{t('url.inner_title')}</GTitle>
          <GSearchWrap>
            <GInput
              type="text"
              ref={(el) => (this.inputRef = el)}
              onKeyDown={this.onInputKeyDown}
              placeholder={t('url.input_placeholder')}
              data-test="search-input-box"
            />
            <GButton>
              <Button colorName="link" dataTest="upload-from-link-btn" className="h-100" icon={SVG_ICONS.ARROW_FORWARD} onClick={this.onUploadClick} />
            </GButton>
          </GSearchWrap>
        </div>
        <TabFooter />
      </>
    );
  }
}

export default connect(
  createStructuredSelector({
    palette: selectPalette,
  })
)(
  TabPanel({
    id: UPLOAD_SOURCES.URL,
  })(UrlTab)
);
